const customUkMessages = {
  csv: {
    buttonMain: {
      label: "Імпортувати",
      tooltip: "Формат '.csv'",
    },
    parsing: {
      collidingIds: "Found colliding 'id' fields",
      failedValidateRow: "CSV не відповідає заданим вимогам",
      invalidCsv: "Документ не може бути розшфрований як 'csv' файл",
    },
    dialogCommon: {
      subtitle: "Імпорт %{count} записів з %{fileName} до '%{resource}'",
      conflictCount:
        "Ресурс <strong>%{resource}</strong> має <strong>%{conflictingCount}</strong> існуючі записи",
      buttons: {
        cancel: "Відмінити",
      },
    },
    dialogImport: {
      alertClose: "Імпортовано %{fname}",
      title: "Імпорт до '%{resource}'",
      buttons: {
        replaceAllConflicts: "Замінити існуючі елементи",
        skipAllConflicts: "Пропустити",
        letmeDecide: "Обрати самостійно",
      },
    },
    dialogDecide: {
      title: "Імпорт id %{id} до '%{resource}'",
      buttons: {
        replaceRow: "Замінити id=%{id}",
        addAsNewRow: "Додати, як новий (Не замінювати)",
        skipDontReplace: "Пропустити (Не замінювати)",
      },
    },
    loading: "Загрузка...",
  },
};

export default customUkMessages;
